import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

// **************************** Update ***************************************
const buildUpdateContractHolderFact = function (errorHandler) {
	return async function ({ policyId, endorsementId, factId, input, store }) {
		const query = gql`
			mutation updateContractHolderFact(
				$policyId: String!
				$endorsementId: String
				$factId: String!
				$input: updateFactInput!
			) {
				updateContractHolderFact(
					policyId: $policyId
					endorsementId: $endorsementId
					factId: $factId
					input: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, factId, input }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.updateContractHolderFact, store)
		return {
			status: res ?.data ?.updateContractHolderFact ?.status,
			id: res ?.data ?.updateContractHolderFact ?.createdStatus ?.id
		}
	}
}

const buildUpdateContractHolderAddress = function (errorHandler) {
	return async function ({ policyId, endorsementId, addressId, input, store }) {
		const query = gql`
			mutation updateContractHolderAddress(
				$policyId: String!
				$endorsementId: String
				$addressId: String!
				$input: updateAddressInput!
			) {
				updateContractHolderAddress(
					policyId: $policyId
					endorsementId: $endorsementId
					addressId: $addressId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, addressId, input }
		const res = await api({ query, variables })

		errorHandler(res ?.errors, res ?.data ?.updateContractHolderAddress, store)
		return {
			status: res ?.data ?.updateContractHolderAddress ?.status,
			id: res ?.data ?.updateContractHolderAddress ?.createdStatus ?.id
		}
	}
}
const buildUpdateContractHolderContact = function (errorHandler) {
	return async function ({ policyId, endorsementId, contactId, input, store }) {
		const query = gql`
			mutation updateContractHolderContact(
				$policyId: String!
				$endorsementId: String
				$contactId: String!
				$input: updateContactInput!
			) {
				updateContractHolderContact(
					policyId: $policyId
					endorsementId: $endorsementId
					contactId: $contactId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, contactId, input }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.updateContractHolderContact, store)
		return {
			status: res ?.data ?.updateContractHolderContact ?.status,
			id: res ?.data ?.updateContractHolderContact ?.createdStatus ?.id
		}
	}
}
const buildUpdateContractHolderIdentity = function (errorHandler) {
	return async function ({ policyId, endorsementId, identityId, input, store }) {
		const query = gql`
			mutation updateContractHolderIdentity(
				$policyId: String!
				$endorsementId: String
				$identityId: String!
				$input: updateIdentityInput!
			) {
				updateContractHolderIdentity(
					policyId: $policyId
					endorsementId: $endorsementId
					identityId: $identityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, identityId, input }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.updateContractHolderIdentity, store)
		return {
			status: res ?.data ?.updateContractHolderIdentity ?.status,
			id: res ?.data ?.updateContractHolderIdentity ?.createdStatus ?.id
		}
	}
}

// *********************************** Add ************************************
const buildAddContractHolderFact = function (errorHandler) {
	return async function ({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation addContractHolderFact(
				$policyId: String!
				$endorsementId: String
				$input: addFactInput!
			) {
				addContractHolderFact(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, input }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.addContractHolderFact, store)
		return {
			status: res ?.data ?.addContractHolderFact ?.status,
			id: res ?.data ?.addContractHolderFact ?.createdStatus ?.id
		}
	}
}

const buildContractHolderFactBatch = function (errorHandler) {
	return async function ({ policyId, input, store }) {
		const query = gql`
			mutation contractHolderFactBatch(
				$policyId: String!
				$input: factBatchInput!
			) {
				contractHolderFactBatch(policyId: $policyId, input: $input) {
					errors_2 {
						code
						message
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, input }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.contractHolderFactBatch, store)
		return {
			status: res ?.data ?.contractHolderFactBatch ?.status,
			id: res ?.data ?.contractHolderFactBatch ?.createdStatus ?.id
		}
	}
}

const buildAddContractHolderAddress = function (errorHandler) {
	return async function ({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation addContractHolderAddress(
				$policyId: String!
				$endorsementId: String
				$input: addressInput!
			) {
				addContractHolderAddress(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, input }
		const res = await api({ query, variables })

		errorHandler(res ?.errors, res ?.data ?.addContractHolderAddress, store)
		return {
			status: res ?.data ?.addContractHolderAddress ?.status,
			id: res ?.data ?.addContractHolderAddress ?.createdStatus ?.id
		}
	}
}
const buildAddContractHolderContact = function (errorHandler) {
	return async function ({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation addContractHolderContact(
				$policyId: String!
				$endorsementId: String
				$input: addContactInput!
			) {
				addContractHolderContact(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, input }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.addContractHolderContact, store)
		return {
			status: res ?.data ?.addContractHolderContact ?.status,
			id: res ?.data ?.addContractHolderContact ?.createdStatus ?.id
		}
	}
}
const buildAddContractHolderIdentity = function (errorHandler) {
	return async function ({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation addContractHolderIdentity(
				$policyId: String!
				$endorsementId: String
				$input: addIdentityInput!
			) {
				addContractHolderIdentity(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, input }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.addContractHolderIdentity, store)
		return {
			status: res ?.data ?.addContractHolderIdentity ?.status,
			id: res ?.data ?.addContractHolderIdentity ?.createdStatus ?.id
		}
	}
}

// *********************************** Remove ************************************
const buildRemoveContractHolderFact = function (errorHandler) {
	return async function ({ policyId, endorsementId, factId, store }) {
		const query = gql`
			mutation removeContractHolderFact(
				$policyId: String!
				$endorsementId: String
				$factId: String!
			) {
				removeContractHolderFact(
					policyId: $policyId
					endorsementId: $endorsementId
					factId: $factId
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, factId }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.removeContractHolderFact, store)
		return {
			status: res ?.data ?.removeContractHolderFact ?.status,
			id: res ?.data ?.removeContractHolderFact ?.createdStatus ?.id
		}
	}
}

const buildRemoveContractHolderAddress = function (errorHandler) {
	return async function ({ policyId, endorsementId, addressId, store }) {
		const query = gql`
			mutation removeContractHolderAddress(
				$policyId: String!
				$endorsementId: String
				$addressId: String!
			) {
				removeContractHolderAddress(
					policyId: $policyId
					endorsementId: $endorsementId
					addressId: $addressId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, addressId }
		const res = await api({ query, variables })

		errorHandler(res ?.errors, res ?.data ?.removeContractHolderAddress, store)
		return {
			status: res ?.data ?.removeContractHolderAddress ?.status,
			id: res ?.data ?.removeContractHolderAddress ?.createdStatus ?.id
		}
	}
}
const buildRemoveContractHolderContact = function (errorHandler) {
	return async function ({ policyId, endorsementId, contactId, store }) {
		const query = gql`
			mutation removeContractHolderContact(
				$policyId: String!
				$endorsementId: String
				$contactId: String!
			) {
				removeContractHolderContact(
					policyId: $policyId
					endorsementId: $endorsementId
					contactId: $contactId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, contactId }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.removeContractHolderContact, store)
		return {
			status: res ?.data ?.removeContractHolderContact ?.status,
			id: res ?.data ?.removeContractHolderContact ?.createdStatus ?.id
		}
	}
}
const buildRemoveContractHolderIdentity = function (errorHandler) {
	return async function ({ policyId, endorsementId, identityId, store }) {
		const query = gql`
			mutation removeContractHolderIdentity(
				$policyId: String!
				$endorsementId: String
				$identityId: String!
			) {
				removeContractHolderIdentity(
					policyId: $policyId
					endorsementId: $endorsementId
					identityId: $identityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, identityId }
		const res = await api({ query, variables })
		errorHandler(res ?.errors, res ?.data ?.removeContractHolderIdentity, store)
		return {
			status: res ?.data ?.removeContractHolderIdentity ?.status,
			id: res ?.data ?.removeContractHolderIdentity ?.createdStatus ?.id
		}
	}
}

export {
	buildUpdateContractHolderAddress,
	buildUpdateContractHolderContact,
	buildUpdateContractHolderFact,
	buildUpdateContractHolderIdentity,
	buildAddContractHolderAddress,
	buildAddContractHolderContact,
	buildAddContractHolderFact,
	buildContractHolderFactBatch,
	buildAddContractHolderIdentity,
	buildRemoveContractHolderAddress,
	buildRemoveContractHolderContact,
	buildRemoveContractHolderFact,
	buildRemoveContractHolderIdentity
}
